import React from 'react';
import ProductButton from './ProductButton';
import {
  StyledButtonsWrapper,
  StyledButtonsTitle,
  StyledButtonsContainer,
} from './ProductButtonGroup.style';

export default class ProductButtonGroup extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { active: null };
    this.setActive = this.setActive.bind(this);
  }

  setActive(name, value) {
    const { onActiveCallback } = this.props;
    this.setState({ active: value });
    onActiveCallback(name, value);
  }

  componentDidMount() {
    const { activeDefault } = this.props;
    this.setActive(activeDefault.name, activeDefault.value);
  }

  componentDidUpdate() {
    const { activeDefault } = this.props;

    if (activeDefault) {
      this.setState({ active: activeDefault.value });
    }
  }

  render() {
    const { active } = this.state;
    const {
      option,
      styles,
      className,
      isDisabled,
    } = this.props;
    const { activeBackgroundColor, activeColor, hoverBackgroundColor, hoverColor } = styles;

    return (
      <StyledButtonsWrapper className={className}>
        <StyledButtonsTitle>{option.name}</StyledButtonsTitle>
        <StyledButtonsContainer>
        {
          option.values.map((v, i) => (
            <ProductButton
              key={v}
              type="button"
              className={
                (i === 0 && 'first')
                || (i === option.values.length - 1 && 'last')
              }
              value={v}
              optionName={option.name}
              onClick={this.setActive}
              activeBackgroundColor={activeBackgroundColor}
              activeColor={activeColor}
              hoverBackgroundColor={hoverBackgroundColor}
              hoverColor={hoverColor}
              disabled={isDisabled}
              isActive={v === active}
            />
          ))
        }
        </StyledButtonsContainer>
      </StyledButtonsWrapper>
    );
  }
}
